import {
  Ard,
  FuseAccountingCentralDatastoreClient,
  GetArdResponse,
} from "@amzn/fuse-accounting-central-datastore-client";
import { createContext, useContext } from "react";
import { ArdRegionMap, ModalMode } from "./types";
import { Domain } from "../../config/BartLambdaConfig";

interface JemGenContextType {
  existingArds: Ard[];
  setExistingArds: (ards: Ard[]) => void;
  selectedArd: Ard | null;
  setSelectedArd: (ard: Ard | null) => void;
  selectedArdDetailed: GetArdResponse | null;
  setSelectedArdDetailed: (getArdResponse: GetArdResponse | null) => void;
  getFacdClient: (
    domain: Domain,
  ) => Promise<FuseAccountingCentralDatastoreClient | null>;
  ardRegionMap: ArdRegionMap;
  setArdRegionMap: (map: ArdRegionMap) => void;
  modalMode: ModalMode;
  setModalMode: (mode: ModalMode) => void;
  toolsContentSelection: string | null;
  setToolsContentSelection: (selection: string | null) => void;
}

export const JemGenContext = createContext<JemGenContextType>({
  existingArds: [],
  setExistingArds: () => {},
  selectedArd: null,
  setSelectedArd: () => {},
  selectedArdDetailed: null,
  setSelectedArdDetailed: () => {},
  getFacdClient: () => Promise.resolve(null),
  ardRegionMap: new Map(),
  setArdRegionMap: () => {},
  modalMode: ModalMode.CREATE,
  setModalMode: () => {},
  toolsContentSelection: null,
  setToolsContentSelection: () => {},
});

export const useJemGen = () => {
  const context = useContext(JemGenContext);
  if (!context) {
    throw new Error("useJemGen must be used within JemGenContextProvider");
  }
  return context;
};
